<div *ngIf="!print || hasInvoices" class="print-item-non-breakable progress-payment">
  <b *ngIf="!print">Progress Payment Invoices</b>
  <b *ngIf="print" style="display:inline-block;margin-top:1rem">Progress Payment Invoices</b>
  <table class="nrk-table">
    <thead>
      <tr>
        <th style="text-align:center;width:8mm">Pos</th>
        <th *ngIf="!disabled && !print"></th>
        <th style="text-align:left">Invoice #</th>
        <th style="text-align:left">DP/PP</th>
        <th style="text-align: center">Issue Date</th>
        <th *ngIf="!print">Base Product</th>
        <th *ngIf="data.visibleMap.prices" [ngStyle]="{'text-align': 'right', 'margin-right': print ? '12.5mm' : '0.5rem'}">Net</th>
        <th *ngIf="!print" style="text-align: center">Pmt Status</th>
        <th *ngIf="!print" style="text-align: center">Pmt Date</th>
        <th *ngIf="!print">Pmnt Pos</th>
        <th *ngIf="print" style="width:10mm"></th>
      </tr>
    </thead>
    <ng-container *ngIf="!tree.isLoading && paymentPlanNumItems">
      <ng-container *ngFor="let ppItem of compilation.paymentPlan.items; index as pos">
        <ng-container *ngIf="ppItem.invoices?.length">
          <ng-container *ngFor="let ppIn of ppItem.invoices">

            <ng-container *ngIf="!paymentPlanInvoice || ppIn === paymentPlanInvoice">
              <tr>
                <td style="text-align:center;width:8mm">{{ compilation.lineItems?.length + compilation.deductibleItems?.length + pos + 1 | nrkPad : 2 }}</td>
                <!-- =============== following is custom pos replacment don't delete ===================-->
                <!-- <td style="text-align:center;width:8mm">{{ (data.getPositionNumberFormat(compilation) | printf : compilation.lineItems?.length + compilation.deductibleItems?.length + pos + 1)}}</td> -->

                <td *ngIf="!disabled && !print" style="width:5rem">
                  <button class="nrk-doc-button" (click)="removePaymentPlanInvoice(ppItem, ppIn)">-</button>
                  <button *ngIf="!disabled && !print" class="nrk-button ml-1" [nbPopover]="deductibleSelection">☰</button>
                  <ng-template #deductibleSelection>
                    <div class="p-3">
                      <table class="nrk-table nrk-row-select">
                        <tr><th>INV #</th><th>Payment</th><th>Issue Date</th><th class="text-right">Net</th></tr>
                        <tr *ngFor="let inv of this.tree.paymentPlanInvoiceData.treeInvoices" (click)="setPaymentPlanInvoice(ppIn, inv);">
                          <td>{{inv.doc.code}}</td>
                          <td>{{inv.payment}}</td>
                          <td>{{inv.issueDate}}</td>
                          <td class="text-right">{{inv.totalNet | currency : inv.doc.currency : 'symbol' : '1.2-2' : 'de'}}</td>
                        </tr>
                      </table>  
                    </div>
                  </ng-template>
                </td>

                <td>
                  <!-- <ng-container *ngIf="!print">
                    <div style="width:10rem">
                      <div class="d-inline-block"><ngx-doc-form-texfield [styles]="{width:'8rem'}" [(value)]="ppIn.code" [disabled]="disabled"></ngx-doc-form-texfield></div>
                      <div class="d-inline-block" *ngIf="!disabled"><ngx-document-in-selector 
                        title="Invoice Selection" [mode]="dlgMode.button" [abstractItem]="compilation"
                        [style]="" buttonText="Invoice Selection" (compilationChange)="ppIn.code = $event.code">
                      </ngx-document-in-selector></div>
                    </div>
                  </ng-container> -->
                  <ng-container>
                    {{ppIn.code}}
                  </ng-container>
                </td>

                <td>
                  <!-- <ngx-doc-form-dropdown *ngIf="!print" [(value)]="ppIn.paymentType" [options]="invoicePaymentOptions" [disabled]="disabled"></ngx-doc-form-dropdown> -->
                  <!-- <ng-container>{{data.getOptionName(invoicePaymentOptions, ppIn.paymentType)}}</ng-container> -->
                  {{data.getOptionName(invoicePaymentOptions, ppIn.paymentType)}}
                </td>

                <td style="text-align: center">
                  <!-- <ngx-doc-form-date *ngIf="!print" class="fullwidth" [(value)]="$any(ppIn).issueDate" [disabled]="disabled"></ngx-doc-form-date> -->
                  <!-- <ng-container>{{ppIn.issueDate | date : 'yyyy-MM-dd'}}</ng-container> -->
                  {{ppIn.issueDate | date : 'yyyy-MM-dd'}}
                </td>

                <td *ngIf="!print"><ngx-doc-form-filter-select [(value)]="ppIn.baseProduct" [options]="baseProductOptions" [disabled]="disabled"></ngx-doc-form-filter-select></td>

                <td *ngIf="data.visibleMap.prices" [ngStyle]="{'text-align': 'right', 'margin-right': print ? '10mm' : '0.5rem'}">
                  <!-- <ngx-doc-form-texfield *ngIf="!print" [styles]="{width:'100%'}" mode="currency" [currency]="compilation.currency" [(value)]="ppIn.net" [disabled]="disabled"></ngx-doc-form-texfield> -->
                  <!-- <ng-container *ngIf="print">{{ppIn.net | currency : compilation.currency : 'symbol' : '1.2-2' : 'de'}}</ng-container> -->
                  {{ppIn.net | currency : compilation.currency : 'symbol' : '1.2-2' : 'de'}}
                </td>
                
                <!-- <td *ngIf="!print"><ngx-doc-form-dropdown [(value)]="ppIn.paymentStatus" [options]="paymentStatusOptions" [disabled]="disabled"></ngx-doc-form-dropdown></td> -->
                <td *ngIf="!print" style="text-align: center">{{data.getOptionName(invoiceStatusOptions, ppIn.paymentStatus)}}</td>

                <!-- <td *ngIf="!print" style="width: 9rem"><ngx-doc-form-date class="fullwidth" [(value)]="$any(ppIn).paymentDate" [disabled]="disabled"></ngx-doc-form-date></td> -->
                <td *ngIf="!print">{{$any(ppIn).paymentDate | date : 'yyyy-MM-dd'}}</td>

                <td *ngIf="!print" style="text-align:center">{{pos + 1 | nrkPad : 2}}</td>

                <td *ngIf="print"></td>

              </tr>
            </ng-container>

          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </table>
</div>
